module.exports = __webpack_public_path__ + "img/logo1.888a96f0.png";